import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { ConfirmationModal } from 'seagull';
import { PdfViewer } from '~/components/PdfViewer/PdfViewer';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useLocaleKeys } from '~/i18n';
import { triggerFileDownload } from '~/infra/utils';
import styles from './pdfViewerModal.module.scss';
export const PdfViewerModal = (param)=>{
    let { title, getFileUrl, onClose, testId, pdfUniqueName, showDownloadButton } = param;
    const { t } = useLocaleKeys();
    const queryClient = useQueryClient();
    const handleDownload = useCallback(async ()=>{
        const url = queryClient.getQueryData([
            QueryKeys.PdfUrl,
            pdfUniqueName
        ]);
        if (url == null) return;
        await triggerFileDownload({
            url,
            filename: pdfUniqueName
        });
    }, [
        queryClient,
        pdfUniqueName
    ]);
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        bi: {
            primaryButton: {
                name: 'pdf_viewer_confirm'
            },
            secondaryButton: {
                name: 'pdf_viewer_cancel'
            }
        },
        overflowContent: true,
        contentPadding: "small",
        width: "800px",
        height: "calc(100% - 128px)",
        title: title,
        onCloseButtonClick: onClose,
        testId: testId,
        primaryButtonLabel: showDownloadButton ? t.common.buttons.downloadPdf() : undefined,
        onPrimaryButtonClick: showDownloadButton ? handleDownload : undefined,
        secondaryButtonLabel: showDownloadButton ? t.common.buttons.close() : undefined,
        onSecondaryButtonClick: showDownloadButton ? onClose : undefined,
        content: /*#__PURE__*/ _jsx("div", {
            className: styles.pdfViewerWrapper,
            children: /*#__PURE__*/ _jsx(PdfViewer, {
                getFileUrl: getFileUrl,
                hideSinglePageLoader: true,
                pdfUniqueName: pdfUniqueName
            })
        })
    });
};
